/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  
  setTimeout(function () {
  window._swat.wishlistCount(
  function(r) {
    if (r > 0) {
      //console.log('Items: ' + $('.swym-wishlist .fa-heart').length);
      $('.swym-wishlist .fa-heart').toggleClass('fas far');
    }
  }
);
  }, 300);
  

  })();

function sizeGuideInit() {
  $('.size-guide-measurement-wrapper .slider-wrapper').click(function() {
    $(this).find('.button').toggleClass('button-right');
    $('.size-guide-table').each(function() {
      $(this).toggleClass('active');
    });
  });
}

function productSizeGuideDisplay() {
  $('.product-size-guide-button').click(function() {
    $('.mr-global-size-guide').addClass('active');
  });
}

function productSizeGuideHide() {
  $('.mr-global-size-guide').click(function(e) {
    if (!$(e.target).closest('.section-size-guide-wrapper').length) {
      $('.mr-global-size-guide').removeClass('active');
    };
  });
}

function scrollToSectionSustainabilityPage() {
  $( ".section-info > h2" ).each(function( index ) {
    let content = $(this).text();
    let newId = content.replace(/[^A-Z0-9]/ig, "");
    $(this).parent().parent().attr("id",newId);
    $(".scroll-to-section").append(`<div data-target="#${newId}" class="scroll-to-target">${content}</div>`);
 
  });

  $('.scroll-to-target').click(function (event) {
    // $('html, body').animate({
    //     scrollTop: $( $(this).attr("href") ).offset().top
    // }, 500); 
    const $this = $(this);
    const $targetValue = $this.data('target'); // if value is 0, scroll to the top most
    const $target = $($targetValue) || false;
    const speed = 1000;
    const offset = $(window).width() <= 767 ? 30 : 125;
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $targetValue ? $target.offset().top - offset : $targetValue - offset
    }, speed);
  });
}

sizeGuideInit();
productSizeGuideDisplay();
productSizeGuideHide();
scrollToSectionSustainabilityPage();